import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { mainnet, polygon, base, baseSepolia } from '@reown/appkit/networks';
import { createAppKit } from '@reown/appkit/vue';
import {writeContract, waitForTransactionReceipt as _waitForTransactionReceipt, getAccount} from '@wagmi/core';
import {abiTestnet as abi, abiUSDC} from './abi.js'


// const CONTRACT_ADDRESS = import.meta.env.VITE_CONTRACT_ADDRESS || "0x88669a8cEb272866c77934a927e59C6Ed5986311";

const projectId = import.meta.env.VITE_PROJECT_ID || "b56e18d47c72ab683b10814fe9495694" // this is a public projectId only to use on localhost
if (!projectId) {
    throw new Error('VITE_PROJECT_ID is not set')
}


const blockchain_network = import.meta.env.VITE_BLOCKCHAIN_NETWORK || 'testnet' ;

export const networks = () => {
    return blockchain_network === 'mainnet' ? [base] : [baseSepolia];
}
// export const networks= [/*mainnet, polygon, base, */baseSepolia];

export const wagmiAdapter = new WagmiAdapter({
    networks: networks(),
    projectId
});

export function initWagmi() {
    const debug = import.meta.env.VITE_WALLET_DEBUG;
    // Initialize AppKit
    const appkit = createAppKit({
        adapters: [wagmiAdapter],
        networks: networks(),
        projectId,
        themeMode: 'light',
        features: {
            connectMethodsOrder: ['wallet'],
            analytics: false, // Optional - defaults to your Cloud configuration
        },
        metadata: {
            name: 'Lend7',
            description: 'Lend7',
            url: import.meta.env.VITE_BASE_URL || 'http://localhost:5173',
            icons: ['https://avatars.githubusercontent.com/u/179229932?s=200&v=4']
        },
        themeVariables: {
            '--w3m-accent': '#000000',
        }
    });


    // appkit.subscribeAccount(state => {
    //     // console.log('appkit.subscribeAccount', JSON.parse(JSON.stringify(state)));
    //     if (state.isConnected) {
    //         const authStore = useAuth();
    //         if (authStore.user) {
    //             authStore.addWalletAddresses(state.allAccounts);
    //         }
    //     }
    // })
    return appkit;
}

export async function signAndPurchase (config, params) {
    const {address} = getAccount(config);
    const _params = {...params, abi, account: address};
    return await writeContract(config, _params);
}

export async function approve (config, params) {
    const {address} = getAccount(config);
    const _params = {...params, abi: abiUSDC, account: address}
    return await writeContract(config, _params);
}

export async function waitForTransactionReceipt (config, hash) {
    return await _waitForTransactionReceipt(config, {
        hash
    });
}
